export default {
  WITHDRAWAL: 'withdrawal',
  DEPOSIT: 'deposit',
  ADDITIONAL: 'additional',
  INVALID_ROUTING_NUMBER: 'invalid_routing_number',
  ROUTING_NUMBER_PENDING: 'routing_number_pending',
  UNCHANGED: 'unchanged',
};
